import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { Button, CoWorkerPicker } from "components";

import { mq, removeArrayItemAt } from "utils";
import { sizes } from "assets/constants";
import css from "styles";

export default function CoWorkers(props: {
  disabled?: boolean;
  value?: Array<{ id?: string | number; name?: string }>;
  onChange: (
    val: Array<{ id: string | number; name: string }> | undefined
  ) => void;
}) {
  const { value, disabled, onChange } = props;
  const [itemsState, setItemsState] = useState<
    { id?: string | number; name?: string }[] | undefined
  >();

  useEffect(() => {
    setItemsState(value);
  }, [value]);

  const _onAdd = (item: any) => {
    const thisIndex = itemsState?.findIndex((e) => e.id === item.id);
    if (Number(thisIndex) > -1) {
      return;
    } else {
      const newItemsState =
        itemsState && itemsState?.length > 0 ? [...itemsState, item] : [item];
      setItemsState(newItemsState);
      onChange(newItemsState);
    }
  };

  const _onRemove = (item: any) => {
    if (itemsState) {
      const thisIndex = itemsState?.findIndex((e) => e.id === item.id);

      const newItemsState = removeArrayItemAt(itemsState, thisIndex);

      setItemsState(newItemsState);
      onChange(newItemsState);
    }
  };

  return (
    <View>
      <CoWorkerPicker disabled={disabled} onSelect={_onAdd} />

      <View style={{ ...css.rRowCenterAlign, ...css.wrap }}>
        {itemsState?.map((item, key) => {
          return (
            <Button
              disabled={disabled}
              onPress={() => _onRemove(item)}
              icon={{ name: "x" }}
              contentSeparator={2}
              title={{ size: "sm", value: item.name }}
              key={String(key)}
              width={"auto"}
              height={mq(25)}
              style={{
                marginTop: sizes.space,
                paddingHorizontal: mq(7),
                marginLeft: sizes.space / 2,
              }}
            />
          );
        })}
      </View>

      <View style={{ height: mq(20) }} />
    </View>
  );
}
